import { apiFetch } from '../../../lib/api';

/**
 * Send presence heartbeat to keep the authenticated user online.
 * Success returns 204 No Content.
 * @param {string} [token] - Optional access token
 */
export const sendPresenceHeartbeat = async (token) => {
  return apiFetch('/api/v1/auth/presence/heartbeat', {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};
